import React from 'react'
import AppLayout from "./routers";
import { ToastProvider } from './components/toast/Toast';

const App = () => {
  return (
    <ToastProvider>
      <AppLayout />
    </ToastProvider>
  )
}

export default App;